<template>
  <v-container class="home">
    <v-form>
      <v-row>
        <v-col cols="12" md="4">
          <v-img src="/maxisu.png" width="275" height="70"></v-img>
          <!-- <span class="title">Pump Selection</span> -->
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3">
          <v-card class="mx-auto">
            <!-- <v-card class="mx-auto" max-width="344"> -->
            <v-card-text>
              <!-- <p class="body-1 text--primary">Frequency (Hz)</p> -->

              <v-text-field
                v-on:keyup.enter="queryPumps"
                inline
                v-model="query.flow"
                :label="`${$t('find.flow')} *`"
                required
              >
                <template v-slot:append-outer>
                  <v-select
                    style="top: -20px"
                    :value="units.flow[0]"
                    offset-y
                    v-model="query.unit_flow"
                    :items="units.flow"
                    :label="`${$t('find.unit')}`"
                  >
                    <template v-slot:item="{ item }">
                      <div v-html="item.text" />
                    </template>
                    <template v-slot:selection="{ item }">
                      <div v-html="item.text" />
                    </template>
                  </v-select>

                  <!-- <v-menu style="top: -12px" offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on">
                        <v-icon left>mdi-menu</v-icon>Menu
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-text class="pa-6">
                        <v-btn large flat color="primary" @click="clickMe">
                          <v-icon left>mdi-target</v-icon>Click me
                        </v-btn>
                      </v-card-text>
                    </v-card>
                  </v-menu>-->
                </template>
              </v-text-field>
              <v-text-field
                v-on:keyup.enter="queryPumps"
                inline
                v-model="query.hm"
                :label="`${$t('find.head')} *`"
                required
              >
                <template v-slot:append-outer>
                  <v-select
                    v-model="query.unit_hm"
                    style="top: -20px"
                    :value="units.hm[0]"
                    offset-y
                    :items="units.hm"
                    :label="`${$t('find.unit')}`"
                  ></v-select>

                  <!-- <v-menu style="top: -12px" offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on">
                        <v-icon left>mdi-menu</v-icon>Menu
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-text class="pa-6">
                        <v-btn large flat color="primary" @click="clickMe">
                          <v-icon left>mdi-target</v-icon>Click me
                        </v-btn>
                      </v-card-text>
                    </v-card>
                  </v-menu>-->
                </template>
              </v-text-field>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="3">
          <v-card class="mx-auto">
            <v-card-text>
              <p class="body-1 text--primary">{{ $t("find.frequency") }} *</p>
              <!-- <div class="text--primary"> -->

              <!-- {{ query.frequency }} -->

              <!-- <v-checkbox
                  v-for="freq in frequencies"
                  :key="freq.value"
                  v-model="query.frequency"
                  :label="freq.text"
                  :value="freq.value"
                  hide-details
              ></v-checkbox>-->

              <v-radio-group v-model="query.frequency">
                <v-radio label="50 Hz" :value="50"></v-radio>
                <v-radio label="60 Hz" :value="60"></v-radio>
              </v-radio-group>

              <!-- </div> -->
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="3">
          <v-card class="mx-auto">
            <v-card-text>
              <p class="body-1 text--primary">{{ $t("find.pump_material") }}</p>
              <!-- <div class="text--primary"> -->

              <!-- {{ query.frequency }} -->
              <v-checkbox
                v-for="material in pump_materials"
                :key="material.value"
                v-model="query.pump_materials"
                :label="
                  `${$t(
                    'find.' + material.text.toLowerCase().replace(' ', '_')
                  )}`
                "
                :value="material.value"
                hide-details
              ></v-checkbox>

              <!-- <v-checkbox v-model="query.frequency" label="60" value="Jacob" hide-details></v-checkbox> -->

              <!-- </div> -->
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <!-- <v-content> -->
        <v-col cols="12">
          <div class="my-2" center>
            <v-btn
              :loading="isLoading"
              @click="queryPumps"
              large
              color="primary"
              >{{ $t("find.start") }}</v-btn
            >
          </div>
        </v-col>
        <!-- </v-content> -->
      </v-row>
    </v-form>

    <v-content style="padding-top:0">
      <v-row>
        <v-col cols="12" md="12" sm="12">
          <v-card v-if="showTable">
            <v-card-title>
              {{ $t("results") }}
              <span>{{ "(" + pumps.length + ")" }}</span>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                :label="$t('search')"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>

            <v-data-table
              :no-data-text="$t('result_no_data_text')"
              multi-sort
              item-key="idid"
              :headers="headers"
              :items="pumps"
              :search="search"
            >
              <template v-slot:item.pump_type="{ item }">
                <a @click="gotoReport(item)">{{
                  item.pump_type + " / " + item.stage
                }}</a>
              </template>

              <template v-slot:item.q="{ item }">{{
                (item.q / flow_carpan).toFixed(2)
              }}</template>

              <template v-slot:item.p2="{ item }">
                {{
                  item.effiency
                    ? (
                        (item.hm * item.q * 0.2718755555555556) /
                        item.effiency
                      ).toFixed(2)
                    : ""
                }}
              </template>

              <template v-slot:item.hm="{ item }">{{
                (item.hm / head_carpan).toFixed(2)
              }}</template>

              <template v-slot:item.fi_e="{ item }">{{
                item.fi_e + '"'
              }}</template>

              <template v-slot:item.total_price="{ item }">{{
                ((item.total_price * 1).toFixed(1) * 1).toLocaleString()
              }}</template>

              <template v-slot:item.motor_price="{ item }">{{
                ((item.motor_price * 1).toFixed(0) * 1).toLocaleString()
              }}</template>

              <template v-slot:item.pump_price="{ item }">{{
                ((item.pump_price * 1).toFixed(0) * 1).toLocaleString()
              }}</template>

              <template v-slot:item.motor_type="{ item }">{{
                item.motor_type + " " + item.motor_power + " HP"
              }}</template>

              <template v-slot:item.cart_add="{ item }">
                <!-- <v-radio-group v-model="item.in_cart" :mandatory="false"> -->
                <!-- <v-radio @click="if (!item.in_cart) addItemToCart(item)" -->
                <!-- :value="1"  -->
                <!-- ></v-radio>  -->
                <!-- GPM ft secildiginde calismiyor -->
                <!-- </v-radio-group> -->

                <div v-if="true">
                  <v-btn
                    @click="addItemToCart(item)"
                    v-if="token && !item.in_cart"
                    icon
                    color="primary"
                  >
                    <!-- <v-btn @click="addToOrderList(item)" v-if="token" icon color="primary"> -->
                    <v-icon>mdi-cart-plus</v-icon>
                  </v-btn>

                  <v-btn
                    @click="deleteItemFromCart(item)"
                    v-if="token && item.in_cart"
                    icon
                    color="green"
                  >
                    <!-- <v-btn @click="addToOrderList(item)" v-if="token" icon color="primary"> -->
                    <v-icon>mdi-cart-minus</v-icon>
                  </v-btn>
                </div>
              </template>

              <!-- addToOrderList(pumpid+''+idmotor,pumpid,idmotor) -->

              <!-- <template @click="/test/" v-slot:item.model="{ item }">
              <a @click="showReport(item)">{{ item.model }}</a>
            </template>
              -->
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-content>
  </v-container>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import cartMethods from "../components/cart.js";
import { checkLogin, handleServerError } from "../components/utils.js";

export default {
  name: "home",

  data: () => ({
    isLoading: false,
    token: "",
    showTable: false,
    selected: [],
    search: "",
    pumps: [],
    savedQuery: {},

    pump_materials: [
      { text: "Stainless Steel", value: "Stainless Steel" },
      { text: "Cast Iron", value: "Cast Iron" },
      // { text: "Noryl", value: "Noryl" }
    ],
    frequencies: [
      { text: "50 Hz", value: 50 },
      { text: "60 Hz", value: 60 },
    ],

    units: {
      hm: ["m", "ft"],
      flow: [
        { text: "m<sup>3</sup>/h", text2: "m3/h", value: "m3_h" },
        { text: "I/sec", text2: "I/sec", value: "l_sec" },
        { text: "I/min", text2: "I/min", value: "l_min" },
        { text: "GPM", text2: "GPM", value: "gpm" },
      ],
    },

    query: {
      pump_materials: [],
      frequency: 50,
      flow: "100",
      hm: "41",
      unit_hm: "m",
      unit_flow: "m3_h",
    },

    flow_carpan: 1.0,
    head_carpan: 1.0,
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t("cart.add"),
          align: "left",
          sortable: false,
          value: "cart_add",
        },
        {
          text: this.$t("pump.model"),
          // text: "Pump Model",
          align: "left",
          sortable: true,
          value: "pump_type",
          width: 120,
        },
        { text: this.$t("pump.diameter") + " (mm)", value: "pump_diameter" },
        { text: this.$t("pump.flow"), value: "q" },
        { text: this.$t("pump.head"), value: "hm" },
        { text: this.$t("pump.effiency") + " (%)", value: "effiency" },
        {
          text: this.$t("system.efficiency") + " (%)",
          value: "system_efficiency",
        },
        { text: this.$t("pump.p2") + " (kW)", value: "p2", sortable: false },
        { text: "NPSHR", value: "npshr" },
        // { text:  this.$t("pump.frequency") +" (Hz)", value: "frequency" },
        { text: this.$t("motor.power") + " (HP)", value: "motor_power" },
        {
          text: this.$t("motor.model"),
          value: "motor_type",
          width: 140,
          sortable: false,
        },
        { text: this.$t("motor.phase"), value: "phase" },
        { text: this.$t("motor.diameter") + " (mm)", value: "motor_diameter" },
        // { text: "Motor Efficiency", value: "motor_effiency" },
        // { text: "Total Effiency", value: "total_effiency" },

        { text: this.$t("pump.material"), value: "material" },
        { text: this.$t("pump.outlet_diameter") + ' (")', value: "fi_e" },
        {
          text: this.$t("pump.price") + " ($)",
          value: "pump_price",
          sortable: false,
        },
        {
          text: this.$t("motor.price") + " ($)",
          value: "motor_price",
          sortable: false,
        },
        {
          align: "right",
          text: this.$t("total_price") + " ($)",
          sortable: false,
          value: "total_price",
        },

        // { text: "Max Shaft Power", value: "max_shaft_power" },
        // { text: "Nominal Diameter", value: "nominal_diameter" },
        // { text: "Outlet Diameter", value: "diameter_outlet" },
        // { text: "Length (mm)", value: "lp" },
        // { text: "Weight (kg)", value: "weight" }
      ];
    },
  },
  components: {
    // HelloWorld
  },
  mounted: function() {
    // this.initLocalStorageCart();
    if (localStorage.token) {
      this.token = localStorage.token;
      this.$http.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${this.token}`;
    } else {
      this.$router.push("/");
      return;
    }
    // alert(this.token)
    this.initSavedQuery();
  },
  methods: {
    deleteItemFromCart: function(item) {
      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + "delete_cart_item",
        data: item,
      })
        .then((response) => {
          // checkLogin(response, this.token)
          console.log(response.data);
          this.queryPumps();
        })
        .catch(function(error) {
          alert(error);
          // handleServerError(error);
          console.log(error);
        });
    },

    addItemToCart: function(item) {
      console.log(item);
      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + "save_cart_item",
        data: item,
      })
        .then((response) => {
          console.log(response.data);
          this.queryPumps();
        })
        .catch(function(error) {
          alert(error);
          console.log(error);
        });
    },
    saveLastQuery: function() {
      const parsed = JSON.stringify(this.query);
      this.$ls.set("saved_query", parsed);
    },
    initSavedQuery: function() {
      try {
        this.query = JSON.parse(this.$ls.get("saved_query", {}));
        this.queryPumps();
      } catch (e) {
        // this.query = {};
      }
    },
    initLocalStorageCart: function() {
      try {
        this.cart = JSON.parse(this.$ls.get("cart", []));
        this.$ls.on("cart", this.cartChanged);
      } catch (e) {
        // alert(e)
        this.cart = [];
        this.$ls.on("cart", this.cartChanged);
      }
    },
    cartChanged: function(val, oldVal, uri) {
      console.log("cart changed -- pumpreport.vue");
      try {
        this.cart = JSON.parse(val);
      } catch (e) {
        this.cart = [];
      }
    },
    addToOrderList: function(pump) {
      const url = this.generateURLForItem(pump);
      cartMethods.addToOrderList(pump, this.cart, url, this.$ls);
    },
    generateURLForItem: function(item) {
      return (
        "/" +
        this.$i18n.locale +
        "/pump_report/" +
        item.idpump +
        "/" +
        item.idpump_perf +
        "/" +
        item.stage +
        "/" +
        this.query.flow +
        "/" +
        this.query.hm +
        "/" +
        this.query.unit_flow +
        "/" +
        this.query.unit_hm +
        "/" +
        item.idmotor +
        "/" +
        item.frequency
      );
    },
    gotoReport: function(item) {
      // console.log(pump_perf_item);
      this.$router.push(this.generateURLForItem(item));

      // window.open(
      //   "/" +
      //     this.$i18n.locale +
      //     "/pump_report/" +
      //     pumpid +
      //     "/" +
      //     idpump_perf +
      //     "/" +
      //     stage +
      //     "/" +
      //     this.query.flow +
      //     "/" +
      //     this.query.hm +
      //     "/" +
      //     this.query.unit_flow +
      //     "/" +
      //     this.query.unit_hm +
      //     "/" +
      //     idmotor +
      //     "/" +
      //     frequency
      //     ,"_blank"
      // );
    },

    queryPumps: function() {
      // console.log(this.query);
      this.pumps = [];

      //aaa
      console.log(this.query);
      this.query.flow = this.query.flow.replace(",", ".");
      this.query.hm = this.query.hm.replace(",", ".");
      console.log(this.query);

      let query_copy = Object.assign({}, this.query);

      if (query_copy.unit_flow == "gpm") this.flow_carpan = 0.2271;
      else if (query_copy.unit_flow == "l_sec") this.flow_carpan = 3.6;
      else if (query_copy.unit_flow == "l_min") this.flow_carpan = 0.06;
      else this.flow_carpan = 1.0;

      query_copy.flow = query_copy.flow * this.flow_carpan;

      if (query_copy.unit_hm == "ft") this.head_carpan = 0.3048;
      else this.head_carpan = 1.0;

      query_copy.hm = query_copy.hm * this.head_carpan;

      this.isLoading = true;
      this.showTable = false;
      this.saveLastQuery();

      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + "query_pumps",
        data: query_copy,
      })
        .then((response) => {
          // checkLogin(response, this.token)

          var flowUnitString = "";
          //  var headUnitString = "";

          this.units.flow.forEach((element) => {
            if (query_copy.unit_flow == element.value)
              flowUnitString = element.text2;
          });

          this.headers[3].text =
            this.$t("find.flow") + " (" + flowUnitString + ")";

          this.headers[4].text =
            this.$t("find.head") + " (" + query_copy.unit_hm + ")";

          this.pumps = response.data;

          this.showTable = true;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
          handleServerError(error);
        });
    },
  },
};
</script>
